import { Wallet } from 'lucide-react'

const Footer = () => {
    return (

        <footer style={{
            background: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(10px)',
            borderTop: '1px solid rgba(255, 255, 255, 0.2)',
            padding: '60px 20px 30px 20px',
            marginTop: '80px'
        }}>
            <div style={{
                maxWidth: '1200px',
                margin: '0 auto'
            }}>
                {/* Main Footer Content */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                    gap: '40px',
                    marginBottom: '40px'
                }}>
                    {/* Brand Section */}
                    <div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            marginBottom: '20px'
                        }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                borderRadius: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)'
                            }}>
                                <Wallet size={20} color="white" />
                            </div>
                            <h3 style={{
                                color: 'white',
                                fontSize: '20px',
                                fontWeight: '700',
                                margin: 0
                            }}>
                                ExpenseTracker
                            </h3>
                        </div>
                        <p style={{
                            color: 'rgba(255, 255, 255, 0.8)',
                            fontSize: '14px',
                            lineHeight: '1.6',
                            margin: '0 0 20px 0',
                            maxWidth: '280px'
                        }}>
                            Take control of your financial future with our intuitive expense tracking platform. Manage budgets, track spending, and gain valuable insights.
                        </p>
                        <div style={{
                            display: 'flex',
                            gap: '15px'
                        }}>
                            <a href="/" style={{
                                width: '40px',
                                height: '40px',
                                background: 'rgba(255, 255, 255, 0.1)',
                                borderRadius: '10px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'rgba(255, 255, 255, 0.8)',
                                textDecoration: 'none',
                                transition: 'all 0.3s ease'
                            }}
                                onMouseOver={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                                    e.target.style.color = 'white';
                                }}
                                onMouseOut={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                                    e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                                }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                                </svg>
                            </a>
                            <a href="/" style={{
                                width: '40px',
                                height: '40px',
                                background: 'rgba(255, 255, 255, 0.1)',
                                borderRadius: '10px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'rgba(255, 255, 255, 0.8)',
                                textDecoration: 'none',
                                transition: 'all 0.3s ease'
                            }}
                                onMouseOver={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                                    e.target.style.color = 'white';
                                }}
                                onMouseOut={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                                    e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                                }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z" />
                                </svg>
                            </a>
                            <a href="/" style={{
                                width: '40px',
                                height: '40px',
                                background: 'rgba(255, 255, 255, 0.1)',
                                borderRadius: '10px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'rgba(255, 255, 255, 0.8)',
                                textDecoration: 'none',
                                transition: 'all 0.3s ease'
                            }}
                                onMouseOver={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                                    e.target.style.color = 'white';
                                }}
                                onMouseOut={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                                    e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                                }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                                </svg>
                            </a>
                        </div>
                    </div>

                    {/* Product Links */}
                    <div>
                        <h4 style={{
                            color: 'white',
                            fontSize: '16px',
                            fontWeight: '600',
                            margin: '0 0 20px 0'
                        }}>
                            Product
                        </h4>
                        <ul style={{
                            listStyle: 'none',
                            padding: 0,
                            margin: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px'
                        }}>
                            <li>
                                <a href="/" style={{
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    textDecoration: 'none',
                                    fontSize: '14px',
                                    transition: 'color 0.3s ease'
                                }}
                                    onMouseOver={(e) => e.target.style.color = 'white'}
                                    onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}>
                                    Features
                                </a>
                            </li>
                            <li>
                                <a href="/" style={{
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    textDecoration: 'none',
                                    fontSize: '14px',
                                    transition: 'color 0.3s ease'
                                }}
                                    onMouseOver={(e) => e.target.style.color = 'white'}
                                    onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}>
                                    Pricing
                                </a>
                            </li>
                            <li>
                                <a href="/" style={{
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    textDecoration: 'none',
                                    fontSize: '14px',
                                    transition: 'color 0.3s ease'
                                }}
                                    onMouseOver={(e) => e.target.style.color = 'white'}
                                    onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}>
                                    Mobile App
                                </a>
                            </li>
                            <li>
                                <a href="/" style={{
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    textDecoration: 'none',
                                    fontSize: '14px',
                                    transition: 'color 0.3s ease'
                                }}
                                    onMouseOver={(e) => e.target.style.color = 'white'}
                                    onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}>
                                    Integrations
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Company Links */}
                    <div>
                        <h4 style={{
                            color: 'white',
                            fontSize: '16px',
                            fontWeight: '600',
                            margin: '0 0 20px 0'
                        }}>
                            Company
                        </h4>
                        <ul style={{
                            listStyle: 'none',
                            padding: 0,
                            margin: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px'
                        }}>
                            <li>
                                <a href="/" style={{
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    textDecoration: 'none',
                                    fontSize: '14px',
                                    transition: 'color 0.3s ease'
                                }}
                                    onMouseOver={(e) => e.target.style.color = 'white'}
                                    onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}>
                                    About Us
                                </a>
                            </li>
                            <li>
                                <a href="/" style={{
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    textDecoration: 'none',
                                    fontSize: '14px',
                                    transition: 'color 0.3s ease'
                                }}
                                    onMouseOver={(e) => e.target.style.color = 'white'}
                                    onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}>
                                    Careers
                                </a>
                            </li>
                            <li>
                                <a href="/" style={{
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    textDecoration: 'none',
                                    fontSize: '14px',
                                    transition: 'color 0.3s ease'
                                }}
                                    onMouseOver={(e) => e.target.style.color = 'white'}
                                    onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}>
                                    Blog
                                </a>
                            </li>
                            <li>
                                <a href="/" style={{
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    textDecoration: 'none',
                                    fontSize: '14px',
                                    transition: 'color 0.3s ease'
                                }}
                                    onMouseOver={(e) => e.target.style.color = 'white'}
                                    onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}>
                                    Contact
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Support Links */}
                    <div>
                        <h4 style={{
                            color: 'white',
                            fontSize: '16px',
                            fontWeight: '600',
                            margin: '0 0 20px 0'
                        }}>
                            Support
                        </h4>
                        <ul style={{
                            listStyle: 'none',
                            padding: 0,
                            margin: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px'
                        }}>
                            <li>
                                <a href="/" style={{
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    textDecoration: 'none',
                                    fontSize: '14px',
                                    transition: 'color 0.3s ease'
                                }}
                                    onMouseOver={(e) => e.target.style.color = 'white'}
                                    onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}>
                                    Help Center
                                </a>
                            </li>
                            <li>
                                <a href="/" style={{
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    textDecoration: 'none',
                                    fontSize: '14px',
                                    transition: 'color 0.3s ease'
                                }}
                                    onMouseOver={(e) => e.target.style.color = 'white'}
                                    onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}>
                                    Documentation
                                </a>
                            </li>
                            <li>
                                <a href="/" style={{
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    textDecoration: 'none',
                                    fontSize: '14px',
                                    transition: 'color 0.3s ease'
                                }}
                                    onMouseOver={(e) => e.target.style.color = 'white'}
                                    onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}>
                                    Community
                                </a>
                            </li>
                            <li>
                                <a href="/" style={{
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    textDecoration: 'none',
                                    fontSize: '14px',
                                    transition: 'color 0.3s ease'
                                }}
                                    onMouseOver={(e) => e.target.style.color = 'white'}
                                    onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}>
                                    Status
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Footer */}
                <div style={{
                    borderTop: '1px solid rgba(255, 255, 255, 0.2)',
                    paddingTop: '30px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '20px'
                }}>
                    <div style={{
                        color: 'rgba(255, 255, 255, 0.7)',
                        fontSize: '14px'
                    }}>
                        © 2024 ExpenseTracker. All rights reserved.
                    </div>
                    <div style={{
                        display: 'flex',
                        gap: '30px',
                        flexWrap: 'wrap'
                    }}>
                        <a href="/" style={{
                            color: 'rgba(255, 255, 255, 0.7)',
                            textDecoration: 'none',
                            fontSize: '14px',
                            transition: 'color 0.3s ease'
                        }}
                            onMouseOver={(e) => e.target.style.color = 'white'}
                            onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.7)'}>
                            Privacy Policy
                        </a>
                        <a href="/" style={{
                            color: 'rgba(255, 255, 255, 0.7)',
                            textDecoration: 'none',
                            fontSize: '14px',
                            transition: 'color 0.3s ease'
                        }}
                            onMouseOver={(e) => e.target.style.color = 'white'}
                            onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.7)'}>
                            Terms of Service
                        </a>
                        <a href="/" style={{
                            color: 'rgba(255, 255, 255, 0.7)',
                            textDecoration: 'none',
                            fontSize: '14px',
                            transition: 'color 0.3s ease'
                        }}
                            onMouseOver={(e) => e.target.style.color = 'white'}
                            onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.7)'}>
                            Cookie Policy
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    )
};

export default Footer;